export enum ContextState {
  RUNNING = 'running',
  SUSPENDED = 'suspended',
  CLOSED = 'closed',
}
